import isFunction from 'lodash/isFunction';
import { defineStore } from 'pinia';
import type { StateTree, StoreDefinition } from 'pinia';

export const genericStoreFactory = <State extends StateTree>(
  defaultState: State | (() => State),
  storeId: string,
): StoreDefinition<string, State> =>
  defineStore(storeId, {
    state: () => {
      if (isFunction(defaultState)) {
        return defaultState();
      }
      return defaultState;
    },
  });
